import { render, staticRenderFns } from "./Etapa6.vue?vue&type=template&id=333ad950&scoped=true"
import script from "./Etapa6.vue?vue&type=script&lang=js"
export * from "./Etapa6.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=333ad950&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa6.vue?vue&type=style&index=1&id=333ad950&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333ad950",
  null
  
)

export default component.exports